import React from "react";
import { Box, Typography } from "@mui/material";
import { ACCENT } from "../BusinessOnboard.constant";

interface IStepHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
}

/** Red "STEP X OF 4" eyebrow + bold title + muted subtitle. */
export const StepHeader: React.FC<IStepHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
}) => (
  <Box sx={{ mb: 2.5 }}>
    <Typography
      sx={{
        fontSize: "0.72rem",
        fontWeight: 800,
        letterSpacing: "0.08em",
        color: ACCENT.main,
        textTransform: "uppercase",
        mb: 0.5,
      }}
    >
      {eyebrow}
    </Typography>
    <Typography
      sx={{
        fontSize: { xs: "1.5rem", md: "1.75rem" },
        fontWeight: 700,
        color: "text.primary",
        lineHeight: 1.15,
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontSize: "0.95rem",
        color: "text.secondary",
        mt: 0.5,
      }}
    >
      {subtitle}
    </Typography>
  </Box>
);
